module.exports = __webpack_public_path__ + "img/p7.690dd29a.png";